// store/reducers/uploadReducer.js
import { createSlice } from '@reduxjs/toolkit';

const uploadSlice = createSlice({
  name: 'upload',
  initialState: {
    uploading: false,
    resumes: [],
  },
  reducers: {
    startUploading: (state) => {
      state.uploading = true;
    },
    stopUploading: (state) => {
      state.uploading = false;
    },
    addResume: (state, action) => {
      state.resumes.push(action.payload);
    },
    clearResumes: (state) => {
      state.resumes = [];
    },
  },
});

export const { startUploading, stopUploading, addResume, clearResumes } = uploadSlice.actions;
export default uploadSlice.reducer;
